module.exports = __webpack_public_path__ + "media/images/logo/product-self-b7e3eb1d879fd2f1f2b1f26d43b5b813.jpg";